<section class="flex w-full flex-col gap-5 p-6 text-[var(--color-text-strong)] sm:p-8">
    <header class="flex flex-col gap-2">
        <h2 class="m-0 font-shBreeHeadline text-2xl leading-tight text-[var(--logo-1)]">
            {{ 'workers-council-groups.select-delegate-dialog.title' | translate }}
        </h2>
        <p class="m-0 text-sm text-[var(--text-secondary)]">
            {{ 'workers-council-groups.select-delegate-dialog.description' | translate }}
        </p>
    </header>

    <sh-input-text
        [formControl]="searchControl"
        [label]="'workers-council-groups.select-delegate-dialog.label' | translate"
        autocomplete="off"
    />

    <div
        class="max-h-72 min-h-24 overflow-y-auto rounded border border-[rgb(var(--ui-6))]"
        role="listbox"
        [attr.aria-busy]="isLoading"
    >
        @if (isLoading) {
            <div class="flex min-h-24 items-center justify-center" role="status">
                <sh-spinner size="s" />
            </div>
        } @else {
            @for (option of (workersCouncilUsers$ | async) ?? []; track option.value.gid) {
                <sh-menu-item
                    [label]="option.label"
                    [active]="selectControl.value?.gid === option.value.gid"
                    (itemClicked)="selectUser(option.value)"
                />
            }
        }
    </div>

    <footer class="flex flex-wrap justify-end gap-2 border-t border-[rgb(var(--ui-6))] pt-4">
        <sh-button
            color="secondary"
            layout="compact"
            icon="arrow-line-left-s"
            iconPosition="left"
            [label]="'workers-council-groups.select-delegate-dialog.close' | translate"
            [ariaLabel]="'workers-council-groups.select-delegate-dialog.close' | translate"
            (clicked)="dialogRef.close()"
        />
        <sh-button
            color="primary"
            layout="compact"
            icon="plus"
            iconPosition="left"
            [label]="'workers-council-groups.select-delegate-dialog.add' | translate"
            [ariaLabel]="'workers-council-groups.select-delegate-dialog.add' | translate"
            [disabled]="selectControl.invalid || isLoading"
            (clicked)="addSelectedUser()"
        />
    </footer>
</section>
